import {setupTable} from "./table";

setupTable()